var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "169", height: "161", viewBox: "0 0 169 161", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Artboard"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "nonzero" },
      React.createElement("path", { d: "M126.906 126.168h-19.068v-10.724h19.066c8.13 0 15.793-3.179 21.579-8.952 5.786-5.77 8.972-13.418 8.972-21.529 0-14.598-10.444-27.18-24.836-29.918l-3.915-.746-.422-3.955c-1.057-9.966-5.605-19.408-12.8-26.589-8.423-8.403-19.568-13.03-31.38-13.03-11.811 0-22.955 4.627-31.38 13.032-7.194 7.18-11.742 16.621-12.8 26.587l-.421 3.95-3.91.75a30.536 30.536 0 0 0-15.869 8.412c-5.786 5.77-8.971 13.41-8.971 21.506 0 16.808 13.706 30.48 30.55 30.48h16.38v10.725H41.298C18.527 126.167 0 107.682 0 84.962c0-10.964 4.303-21.295 12.121-29.09a41.258 41.258 0 0 1 17.65-10.45c1.97-10.983 7.337-21.254 15.35-29.25C55.579 5.743 69.422 0 84.104 0c14.682 0 28.524 5.743 38.98 16.172 8.014 7.997 13.38 18.266 15.349 29.248 17.465 5.06 29.773 21.112 29.773 39.543 0 10.977-4.303 21.317-12.121 29.113-7.816 7.796-18.178 12.092-29.178 12.092z", fill: "#CFCFCF" }),
      React.createElement("path", { d: "M76.751 138.759v-29.243a6.393 6.393 0 0 1 6.374-6.377c3.506 0 6.375 2.87 6.375 6.377v29.243l6.72-6.725a6.389 6.389 0 0 1 9.015 0 6.397 6.397 0 0 1 0 9.018l-17.595 17.62c-2.341 2.343-6.738 2.292-9.03 0l-17.594-17.62a6.395 6.395 0 0 1 0-9.018 6.389 6.389 0 0 1 9.013 0l6.722 6.725z", fill: "#2D9F86" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/export-download.svg